import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { Invoice } from '~hooks/useInvoices/models';
import { dateFormat } from '~utils/dateTime';

import { SHEET_DATE_FORMAT } from './settlementSheetDisplay';

interface LabeledValueProps {
  label: string;
  value: string;
}

function LabeledValue({ label, value }: LabeledValueProps) {
  return (
    <Typography variant="body2">
      <Box component="span" sx={{ fontWeight: 600 }}>
        {label}:
      </Box>{' '}
      {value}
    </Typography>
  );
}

interface SettlementSheetOrderHeaderProps {
  invoice: Invoice;
}

export default function SettlementSheetOrderHeader({
  invoice: { job, order, project },
}: SettlementSheetOrderHeaderProps) {
  const dispatch = order?.dispatchNumber?.name ?? order?.name;

  return (
    <Box
      data-test-id="settlement-sheet-order-header"
      sx={(theme) => ({
        alignItems: 'center',
        bgcolor: theme.semantic.surfaceSunken,
        borderBottom: `1px solid ${theme.semantic.borderStrong}`,
        display: 'flex',
        flexWrap: 'wrap',
        gap: 2,
        px: 2,
        py: 1,
      })}
    >
      {dispatch && (
        <LabeledValue
          label={t('approvals.driver_pay.settlements.pdf.dispatch')}
          value={
            job
              ? t('approvals.driver_pay.settlements.sheet.dispatch_with_date', {
                  date: dateFormat(job.jobStartAt, SHEET_DATE_FORMAT),
                  dispatch,
                })
              : dispatch
          }
        />
      )}
      {project && (
        <LabeledValue
          label={t('approvals.driver_pay.settlements.pdf.project')}
          value={
            project.externalId
              ? t('approvals.driver_pay.settlements.sheet.project_with_external_id', {
                  externalId: project.externalId,
                  name: project.name,
                })
              : project.name
          }
        />
      )}
      {order?.orderId && (
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {order.orderId}
        </Typography>
      )}
    </Box>
  );
}
